import { render } from "./Account.vue?vue&type=template&id=1b64281a&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=1b64281a&lang=scss&scoped=true"

import exportComponent from "/var/www/sites/qiyas.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b64281a"]])

export default __exports__